var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.relatorio.DiscussaoZootecnicoText &&
    _vm.relatorio.DiscussaoZootecnicoText != ''
  )?_c('v-card',{staticClass:"ma-4"},[_c('v-card-title',{staticStyle:{"text-align":"left"}},[_vm._v("Discussões de indicadores zootécnicos")]),_c('v-card-text',[_c('v-row',{staticClass:"pa-3"},[_c('v-col',{staticClass:"col-bordered",attrs:{"cols":"12"}},[_c('span',{staticClass:"value-title"},[_vm._v(_vm._s(_vm.relatorio.DiscussaoZootecnicoText || '-'))])])],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }